<template>
  <div>
    <Breadcrumbs main="Rutas" title="Trabajadores"/>
    <!-- Container-fluid starts-->
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <h5>Posición de los trabajadores y despachos activos</h5>
              <p>Los marcadores verdes del mapa hacen referencia a los despachos en entrega.</p>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-12 mb-3">
                  <GmapMap style="width: 100%; height: 500px"
                           :center="optionsMap.center"
                           :zoom="optionsMap.zoom">
                    <gmap-info-window :options="infoOptions" :position="infoWindowPos" :opened="infoWinOpen" @closeclick="infoWinOpen=false"></gmap-info-window>
                    <gmap-custom-marker v-for="(m, i) in marker" :marker="m.position" :key="i" @click.native="toggleInfoWindow(m,i)">
                      <img src="../../../assets/images/google-maps-marker.png" alt="posición" width="25px" height="40px"/>
                    </gmap-custom-marker>
                    <gmap-custom-marker v-for="(m, i) in markerDispatch" :marker="m.position" :key="i + 2000" @click.native="toggleInfoWindow(m, i + 2000)">
                      <img src="../../../assets/images/google-maps-marker-red.png" alt="posición" width="25px" height="40px"/>
                    </gmap-custom-marker>
                  </GmapMap>
                </div>
              </div>
              <b-row>
                <b-col md="12">
                  <b-input-group class="datatable-btn" >
                    <b-form-input v-model="datatableOptions.filter" placeholder="Buscar..."></b-form-input>
                  </b-input-group>
                </b-col>
              </b-row>
              <div class="table-responsive datatable-vue">
                <b-table
                        show-empty
                        stacked="md"
                        :items="datatableOptions.items"
                        :fields="datatableOptions.tablefields"
                        :filter="datatableOptions.filter"
                        :current-page="datatableOptions.currentPage"
                        :per-page="datatableOptions.perPage"
                        @filtered="onFiltered"
                >
                  <template v-slot:cell(color)="data">
                    <span class="badge" :style="{'background-color': data.item.color}"><i class="fa"></i></span>
                  </template>
                </b-table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Container-fluid Ends-->
  </div>
</template>

<script>
  import axios from 'axios';
  import GmapCustomMarker from "vue2-gmap-custom-marker";
  import utils from '../../../utils';

  export default {
    components: {
      'gmap-custom-marker': GmapCustomMarker
    },
    data(){
      return {
        interval: null,
        // TIEMPO DE REFRESCO (SEGUNDOS)
        time: 30,
        marker: [],
        markerDispatch: [],
        optionsMap: {
          center: {
            lat: -33.4488897,
            lng: -70.6692655
          },
          zoom: 12
        },
        // PARA SABER SI EL INFOWINDOWS ESTÁ ABIERTO
        infoWinOpen: false,
        infoWindowPos: null,
        currentMidx: null,
        infoOptions: {
          content: '',
          //optional: offset infowindow so it visually sits nicely on top of our marker
          pixelOffset: {
            width: 0,
            height: -35
          }
        },
        datatableOptions: {
          tablefields: [
            { key: 'color', label: 'Color', sortable: false, class: 'text-center'},
            { key: 'worker', label: 'Trabajador', sortable: true},
            { key: 'vehicle', label: 'Vehículo', sortable: true},
            { key: 'current_position', label: 'Posición Actual', sortable: true},
            { key: 'last_update', label: 'Última actualización', sortable: true},
          ],
          items: [],
          filter: null,
          totalRows: 1,
          currentPage: 1,
          perPage: 10,
        },
      }
    },
    mounted () {
      this.getLastPositionWorker();
      this.interval = setInterval(() => {
        this.getLastPositionWorker();
      }, this.time * 1000);
      this.getDispatch(this.markerDispatch);
    },
    beforeDestroy () {
      clearInterval(this.interval);
    },
    methods: {
      getLastPositionWorker(){
        const path = '/api/route/v1.0/get_last_position_workers/';
        axios.get(path).then((response) => {
          this.marker = [];
          if(response.status === 200){
            this.datatableOptions.items = [];
            response.data.forEach((element) => {
              const vehicle = (element['vehicle'] !== null) ? element['vehicle']['patent'] : 'Sin vehículo';
              // AGREGAMOS EL MARCADOR Y LA INFOWINDOW
              this.marker.push(
                  {
                    color: element['worker']['color'].replace('#', ''),
                    position: {
                      lat: parseFloat(element['lat']),
                      lng: parseFloat(element['lng'])
                    },
                    infoText: '<div>' +
                        `<p>Trabajador: <b>${element['worker']['full_name']}</b></p>` +
                        `<p>Vehículo actual: <b>${vehicle}</b></p>` +
                        `<p>Posición actual: <b>${element['address']}</b></p>` +
                        '<br>' +
                        `<p><small>Última actualización: <b>${element['date_send']}</b></small></p>` +
                        '</div>'

                  }
              );
              // AGREGAMOS LOS VALORES A LA TABLA
              this.datatableOptions.items.push(
                  {
                    'color': element['worker']['color'],
                    'worker': element['worker']['full_name'],
                    'vehicle': vehicle,
                    'current_position': element['address'],
                    'last_update': element['date_send']
                  }
              )
            });
          }
        });
      },
      getColor(color){
        return `../../../assets/images/google-maps-marker.png`;
      },
      toggleInfoWindow(marker, idx) {
        this.infoWindowPos = marker.position;
        this.infoOptions.content = marker.infoText;

        //check if its the same marker that was selected if yes toggle
        if (this.currentMidx === idx) {
          this.infoWinOpen = !this.infoWinOpen;
        }
        //if different marker set infowindow to open and reset current marker index
        else {
          this.infoWinOpen = true;
          this.currentMidx = idx;

        }
      },
      onFiltered(filteredItems) {
        // Trigger pagination to update the number of buttons/pages due to filtering
        this.datatableOptions.totalRows = filteredItems.length;
        this.datatableOptions.currentPage = 1
      },
      async getDispatch(markersList){
        const path = `/api/inventory/v1.0/dispatch/`;
        const config = {
          params: {
            status: '220'
          }
        };
        await axios.get(path, config).then(async (response) => {
          // response.data.forEach(item => markersList.push({lat: item['lat'], lng: item['lng'], color: 'FF0000'}));
          response.data.forEach((item) => {
            // item['color'] = 'FF0000';
            markersList.push({
              color: '00FF00',
              position: {
                lat: parseFloat(item['lat']),
                lng: parseFloat(item['lng'])
              },
              infoText: '<div>' +
                  '<p><strong>Despacho:</strong></p>' +
                  `<p>Nombre: <b>${item['name']}</b></p>` +
                  `<p>Dirección: <b>${item['address']}</b></p>` +
                  `<p>Obrsevación de la dirección: <b>${(item['observation'] !== null && item['observation'] !== "") ? item['observation'] : 'Sin observación de dirección adicional'}</b></p>` +
                  `<p>Obrsevación de despacho: <b>${(item['additional_observation'] !== null && item['additional_observation'] !== "") ? item['additional_observation'] : 'Sin observación de despacho adicional'}</b></p>` +
                  '<br>' +
                  '</div>'
            });
          });
          // markersList = response.data;
        }).catch((error) => {
          console.log(error.response);
        });
      }
    }
  }
</script>
<style>
  .datatable-btn .form-control {
    border: 1px solid #cdcfd8 !important;
  }
</style>
